import { BrowserRouter } from 'react-router'
import { ErrorBoundary } from 'react-error-boundary'
import { AuthProvider } from '@klear/ui/contexts/auth-context'
import { requestBuildVersionCheck } from '@klear/ui/hooks/use-build-version-gate'

import { Toaster } from '@klear/ui/components/toaster'
import AppRoutes from '@/app/routes'
import LegalAgreements from '@/app/legal-agreements'
import { TraderErrorFallback } from '@/components/trader-error-fallback'
import { useClientErrorReporting } from '@/hooks/use-client-error-reporting'

function AppShell() {
  const onReportError = useClientErrorReporting()

  const onError = (error: Error, info: { componentStack?: string | null }) => {
    requestBuildVersionCheck()
    onReportError(error, info)
  }

  return (
    <ErrorBoundary FallbackComponent={TraderErrorFallback} onError={onError}>
      <AuthProvider>
        <AppRoutes />
        <LegalAgreements />
        <Toaster />
      </AuthProvider>
    </ErrorBoundary>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  )
}

export default App
